import { gql } from 'apollo-boost';

export const COURSE_LIST_QUERY = gql`
    query courseList {
        courseList {
            courses {
                id
                thumbnailImage
                name
                launchURL
            }
        }
    }
`;
